import PropTypes from 'prop-types';

import { useState } from 'react';
// @mui
import { Stack, MenuItem, Grid, Typography, TextField, Divider, Snackbar, Alert } from '@mui/material';
import api from 'src/utils/api';
import { LoadingButton } from '@mui/lab';

// ----------------------------------------------------------------------

CreateReport.propTypes = {
    success: PropTypes.func.isRequired,
};

export default function CreateReport({ success }) {
    const [title, setTitle] = useState('');
    const [url] = useState('');
    const [, setError] = useState('');
    const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'error' });

    const handleClick = () => {
        if (title !== '' && url !== '')
            api.post('video-api/create', { title, url, type: 1 })
                .then((result) => {
                    if (result.id) success();
                    else if (result.status === "error") setError(result.message);
                })
                .catch((err) => {
                    api.logError('create report failed', err);
                    setError('true');
                    setSnackbar({ open: true, message: err?.message || 'Помилка при створенні звіту', severity: 'error' });
                });
        else setError('true');
    };

    return (
        <>
            <Stack>
                <Divider sx={{ mb: 3 }} />
                    <Grid container rowSpacing={2}>
                        <Grid item xs={12} md={12} lg={12}>
                            <TextField
                                select
                                fullWidth
                                value={title}
                                label="Група"
                                onChange={(event) => {
                                    setTitle(event.target.value);
                                }}
                            >
                                <MenuItem value={10}>Ten</MenuItem>
                                <MenuItem value={20}>Twenty</MenuItem>
                                <MenuItem value={30}>Thirty</MenuItem>
                            </TextField>
                        </Grid>

                        <Grid item xs={12} md={12} lg={12} sx={{ mb: '10px' }}>
                            <Typography>Оберіть матеріали, які використовували на уроці:</Typography>
                        </Grid>

                        <Grid container xs={12} md={12} lg={12} rowSpacing={2}>
                            <Grid item xs={12} md={6} lg={6}>
                                <TextField
                                select
                                    // labelId="demo-simple-select-label"
                                    // id="demo-simple-select"
                                    name="title"
                                    fullWidth
                                    value={title}
                                    label="Група"
                                    onChange={(event) => {
                                        setTitle(event.target.value);
                                    }}
                                >
                                    <MenuItem value={10}>Ten</MenuItem>
                                    <MenuItem value={20}>Twenty</MenuItem>
                                    <MenuItem value={30}>Thirty</MenuItem>
                                </TextField>
                            </Grid>
                            <Grid item xs={12} md={6} lg={6}>
                                <TextField
                                select
                                    // labelId="demo-simple-select-label"
                                    // id="demo-simple-select"
                                    name="title"
                                    fullWidth
                                    value={title}
                                    label="Група"
                                    onChange={(event) => {
                                        setTitle(event.target.value);
                                    }}
                                >
                                    <MenuItem value={10}>Ten</MenuItem>
                                    <MenuItem value={20}>Twenty</MenuItem>
                                    <MenuItem value={30}>Thirty</MenuItem>
                                </TextField>
                            </Grid>

                            <Grid item xs={12} md={6} lg={6}>
                                <TextField
                                select
                                    // labelId="demo-simple-select-label"
                                    // id="demo-simple-select"
                                    name="title"
                                    fullWidth
                                    value={title}
                                    label="Група"
                                    onChange={(event) => {
                                        setTitle(event.target.value);
                                    }}
                                >
                                    <MenuItem value={10}>Ten</MenuItem>
                                    <MenuItem value={20}>Twenty</MenuItem>
                                    <MenuItem value={30}>Thirty</MenuItem>
                                </TextField>
                            </Grid>
                            <Grid item xs={12} md={6} lg={6}>
                                <TextField
                                select
                                    // labelId="demo-simple-select-label"
                                    // id="demo-simple-select"
                                    name="title"
                                    fullWidth
                                    value={title}
                                    label="Група"
                                    onChange={(event) => {
                                        setTitle(event.target.value);
                                    }}
                                >
                                    <MenuItem value={10}>Ten</MenuItem>
                                    <MenuItem value={20}>Twenty</MenuItem>
                                    <MenuItem value={30}>Thirty</MenuItem>
                                </TextField>
                            </Grid>
                        </Grid>
                        <Grid item xs={12} md={12} lg={12}>
                            <LoadingButton fullWidth size="large" type="submit" variant="contained" onClick={handleClick}>
                                Додати
                            </LoadingButton>
                        </Grid>
                    </Grid>

            </Stack>
                    <Snackbar open={snackbar.open} autoHideDuration={4000} onClose={() => setSnackbar(s => ({ ...s, open: false }))} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}>
                        <Alert onClose={() => setSnackbar(s => ({ ...s, open: false }))} severity={snackbar.severity} sx={{ width: '100%' }}>
                            {snackbar.message}
                        </Alert>
                    </Snackbar>
        </>
    );
}
